import { Wrench, ShieldCheck, LifeBuoy, Home } from 'lucide-react';
import ChimneyImage from '../../img/Cooking-range-img.png';
import CTA from '../Cta';

function CookingRangeService() {
    return (
        <div className="chimney-repair-container">
            {/* Hero Section - No content, just introductory information */}
            <section className="chimney-repair-hero">
                <div className="chimney-repair-hero-content">
                    <h1 className="chimney-repair-title">Professional Cooking Range Repair</h1>
                    <p className="chimney-repair-subtitle">
                        Get your cooking range working like new with our expert repair service. Whether it’s ignition issues, uneven heating, or faulty gas flow, we fix it all with precision and care.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Our technicians are trained to service all brands and models of cooking ranges, ensuring high performance and long-term reliability.
                    </p>
                    <p className="chimney-repair-subtitle">
                        We inspect, diagnose, and repair issues efficiently to minimize downtime and ensure your kitchen is always ready to go.
                    </p>
                    <p className="chimney-repair-subtitle">
                        Schedule a quick inspection today and experience hassle-free repair service that prioritizes your safety and convenience.
                    </p>

                    <button className="chimney-repair-cta-btn"
                        onClick={() => (window.location.href = "tel:70390 34000")}
                        style={{ cursor: "pointer" }}>
                        Book a Service Now
                    </button>
                </div>
            </section>

            <div className="chimney-repair-service-img">
                <img src={ChimneyImage} alt="Cooking Range Repair" />
            </div>

            {/* Section 1: Why Choose Us */}
            <section className="chimney-repair-why-choose">
                <div className="chimney-repair-why-content">
                    <h2 className="chimney-repair-heading">Why Choose Our Cooking Range Service?</h2>
                    <div className="chimney-repair-why-grid">
                        <div className="chimney-repair-why-item">
                            <Wrench size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Expert Technicians</h3>
                            <p className="chimney-repair-description">
                                Skilled in resolving gas, ignition, and heating issues with top-tier tools and techniques.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <ShieldCheck size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Gas Safety Priority</h3>
                            <p className="chimney-repair-description">
                                All repairs are conducted with a strict focus on safety and compliance.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <LifeBuoy size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Quick Response</h3>
                            <p className="chimney-repair-description">
                                We provide emergency services to get your cooking range back in action fast.
                            </p>
                        </div>
                        <div className="chimney-repair-why-item">
                            <Home size={36} className="chimney-repair-icon" />
                            <h3 className="chimney-repair-subheading">Affordable Service</h3>
                            <p className="chimney-repair-description">
                                Get premium repair service at competitive pricing with no hidden costs.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Section 2: Our Process */}
            <section className="chimney-repair-process">
                <h2 className="chimney-repair-heading">Our Cooking Range Repair Process</h2>
                <div className="chimney-repair-process-steps">
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 1: Diagnostic Check</h3>
                        <p className="chimney-repair-step-description">
                            We assess the appliance to pinpoint exact faults and provide a suitable plan.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 2: Transparent Estimate</h3>
                        <p className="chimney-repair-step-description">
                            Receive an upfront quote with no surprises and a clear breakdown of services.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 3: Precise Repair</h3>
                        <p className="chimney-repair-step-description">
                            Our experts perform repairs using the best practices and quality parts.
                        </p>
                    </div>
                    <div className="chimney-repair-step">
                        <h3 className="chimney-repair-step-title">Step 4: Function Test</h3>
                        <p className="chimney-repair-step-description">
                            We ensure everything is working perfectly before closing the job.
                        </p>
                    </div>
                </div>
            </section>

            <CTA />
        </div>
    );
}

export default CookingRangeService;